import { computed } from 'vue'
import { useStore } from 'vuex'

export const schoolStore = () => {
  const store = useStore()
  
  const clsList = computed(() => store.state.Classes)
  const secList = computed(() => store.state.Sections)
  const examList = computed(() => store.state.ExamTypes)
  const subList = computed(() => store.state.Subjects)
  const profile = computed(() => store.state.Profile)
  const uniqueClsList = computed(() => {
    const seen = new Set();
    return clsList.value.filter(item => {
      const lowerName = item.name.toLowerCase();
      if (seen.has(lowerName)) return false;
      seen.add(lowerName);
      return true;
    });
  })

  return { clsList, uniqueClsList, secList, examList, subList, profile }
}
